export default __webpack_public_path__ + "static/media/expImgBlack.01d2dd8e.svg";